import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const topCategories = categories.slice(6, 11);
  const moreFinds = categories.slice(11, 14);

  return (
    <footer className="relative overflow-hidden">
      <div className="bg-foreground-950 rounded-t-[2rem] px-6 md:px-10 pt-16 pb-10 mx-3 md:mx-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="text-2xl font-heading font-bold italic text-background-50 whitespace-nowrap inline-block mb-8"
            >
              Pandabuy<span className="text-accent-500 not-italic">.homes</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-xs">
              Your curated hub for the best pandabuy sheet collections. Helping shoppers discover quality products through organized, searchable spreadsheets since 2025.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              <strong>Top Categories</strong>
            </h4>
            <div className="flex flex-col gap-2.5">
              {topCategories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              <strong>More Finds</strong>
            </h4>
            <div className="flex flex-col gap-2.5">
              {moreFinds.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className={`${cat.icon} text-xs`}></i>
                  </span>
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              <strong>Stay Updated</strong>
            </h4>
            <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
              Get the latest drops and spreadsheet updates delivered to your inbox.
            </p>
            <form
              id="newsletter-form-footer"
              className="flex gap-0"
              data-readdy-form="true"
              action="https://readdy.ai/api/form/d917k9obhec1he3opq1g"
              method="POST"
            >
              <input
                type="email"
                name="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2.5 bg-foreground-800/50 border border-foreground-700/50 rounded-l-full text-sm text-background-50 placeholder:text-foreground-500 outline-none focus:border-accent-500/50 transition-colors"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="anti-spam-field"
              />
              <button
                type="submit"
                className="w-11 h-11 flex items-center justify-center bg-accent-500 rounded-r-full hover:bg-accent-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-arrow-right-line text-background-50 text-lg"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 max-w-7xl mx-auto">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Pandabuy.homes. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">
              Home
            </Link>
            <Link to="/guides/best-pandabuy-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">
              Guides
            </Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">
              Pandabuy Sheet
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 pointer-events-none select-none overflow-hidden">
          <span className="block text-[10rem] md:text-[14rem] font-heading font-black text-foreground-800/10 leading-none whitespace-nowrap">
            PANDABUY
          </span>
        </div>
      </div>
    </footer>
  );
}